/*
jQuery BigText v1.3.0, May 2014

Usage:
$("#div").bigText({
	rotateText: {Number}, (null)
	fontSizeFactor: {Number}, (0.8)
	maximumFontSize: {Number}, (null)
	limitingDimension: {Number}, ("both")
	horizontalAlign: {String}, ("center")
	verticalAlign: {String}, ("center")
	textAlign: {String}, ("center")
});

https://github.com/DanielHoffmann/jquery-bigtext

Options:

rotateText: Rotates the text inside the element by X degrees.

fontSizeFactor: This option is used to give some vertical spacing for letters that overflow the line-height (like 'g', 'Á' and most other accentuated uppercase letters). This does not affect the font-size if the limiting factor is the width of the parent div. The default is 0.8

maximumFontSize: maximum font size to use.

limitingDimension: In which dimension the font size should be limited. Possible values: "width", "height" or "both". Defaults to both. Using this option with values different than "both" overwrites the element parent width or height.

horizontalAlign: Where to align the text horizontally. Possible values: "left", "center", "right". Defaults to "center".

verticalAlign: Where to align the text vertically. Possible values: "top", "center", "bottom". Defaults to "center".

textAlign: Sets the text align of the element. Possible values: "left", "center", "right". Defaults to "center". This option is only useful if there are linebreaks (<br> tags) inside the text.

whiteSpace: Sets whitespace handling. Possible values: "nowrap", "pre". Defaults to "nowrap". (Can also be set to enable wrapping but this doesn't work well.)

Copyright (C) 2013 Daniel Hoffmann Bernardes, Ícaro Technologies

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



(function($){
    "use strict";
    var defaultOptions= {
        rotateText: null,
        fontSizeFactor: 1,
        maximumFontSize: null,
        limitingDimension: "both",
        horizontalAlign: "center",
        verticalAlign: "center",
        textAlign: "center",
        whiteSpace: "nowrap",
        minimumScale: 0.55
    };

    $.fn.bigText= function(options) {
        return this.each(function() {
            options= $.extend({}, defaultOptions, options);
            var $this= $(this);//eg .large-one
            var $parent= $this.parent();// .holder

            //hides the element to prevent "flashing"
            $this.css("visibility", "hidden");

            $this.css({
                display: "inline-block",
                clear: "both",
                'float': "left", //the need to set this is very odd, its due to margin-collapsing. See https://developer.mozilla.org/en-US/docs/Web/CSS/margin_collapsing
                'font-size': (1000 * options.fontSizeFactor) + "px",
                'line-height': "1em",//1000px
                'white-space': options.whiteSpace,
                "text-align": options.textAlign,
                position: "relative",
                padding: 0,
                margin: 0,
                left: "50%"
                // ,
                // top: "50%"
            });

            var parentPadding= {
                left: parseInt($parent.css('padding-left')),
                top: parseInt($parent.css('padding-top')),
                right: parseInt($parent.css('padding-right')),
                bottom: parseInt($parent.css('padding-bottom'))
            };

            var box= {
                width: $this.outerWidth(),
                height: $this.outerHeight()
            };
            var rotateCSS= {};
            if (options.rotateText !== null) {
                if (typeof options.rotateText !== "number") {
                    throw "bigText error: rotateText value must be a number";
                }
                var rotate= "rotate(" + options.rotateText + "deg)";
                rotateCSS= {
                    "-webkit-transform": rotate,
                    "-ms-transform": rotate,
                    "-moz-transform": rotate,
                    "-o-transform": rotate,
                    "transform": rotate
                };
                $this.css(rotateCSS);
                //calculating bounding box of the rotated element
                var sin= Math.abs(Math.sin(options.rotateText * Math.PI / 180));
                var cos= Math.abs(Math.cos(options.rotateText * Math.PI / 180));
                box.width= $this.outerWidth() * cos + $this.outerHeight() * sin;
                box.height= $this.outerWidth() * sin + $this.outerHeight() * cos;
            }

            var widthFactor= ($parent.innerWidth() - parentPadding.left - parentPadding.right) / box.width;
            var heightFactor= ($parent.innerHeight() - parentPadding.top - parentPadding.bottom) / box.height;
            var lineHeight;

            if (options.limitingDimension.toLowerCase() === "width") {
                lineHeight= Math.floor(widthFactor * 1000);
                $parent.height(lineHeight);
            } else if (options.limitingDimension.toLowerCase() === "height") {
                lineHeight= Math.floor(heightFactor * 1000);
            } else if (widthFactor < heightFactor) {
                lineHeight= Math.floor(widthFactor * 1000);
            } else if (widthFactor >= heightFactor) {
                lineHeight= Math.floor(heightFactor * 1000);
            }
            
            // set basics for txt start size, higher txtScale = taller letters
            var fontSize = lineHeight * options.fontSizeFactor;
            var txtScale = 1.6 - (lineHeight/100);
            var minimumScale = 0.55;

            //set minimum so txt is never tooooo flat...
            if (txtScale < options.minimumScale) {
                minimumScale = options.minimumScale;
            } else {
                minimumScale = txtScale;
            }
            
            if (options.maximumFontSize !== null && fontSize > options.maximumFontSize) {
                fontSize= options.maximumFontSize;
                lineHeight= fontSize; // / options.fontSizeFactor
            }            

            $this.css({
                'font-size': Math.floor(fontSize) + "px",
                'line-height': Math.floor(fontSize) + "px", //Math.ceil(lineHeight) + "px",
                'margin-bottom': "0px",
                'margin-right': "0px",
                'transform':"scale(1, " + minimumScale + ")" + "translateX(-" + (minimumScale/10) + 'em' + ")"
            });

            if (options.limitingDimension.toLowerCase() === "height") {
                //this option needs the font-size to be set already so $this.width() returns the right size
                //this +4 is to compensate the rounding erros that can occur due to the calls to Math.floor in the centering code
                $parent.width(($this.width() + 4) + "px");
            }
            var endCSS= {};

            switch(options.verticalAlign.toLowerCase()) {
                case "top":
                    endCSS.top = "0%";
                break;
                case "bottom":
                    endCSS.top = "100%";
                    endCSS['margin-top']= Math.floor(-$this.innerHeight()) + "px";
                break;
                default:
                    endCSS['margin-top']= Math.floor((-$this.innerHeight() / 1.8)) + "px";
                break;
            }

            switch(options.horizontalAlign.toLowerCase()) {
                case "left":
                    endCSS.left = "0%";
                break;
                case "right":
                    endCSS.left = "100%";
                    endCSS['margin-left']= Math.floor(-$this.innerWidth()) + "px";
                break;
                default:
                    endCSS['margin-left']= Math.floor((-$this.innerWidth() / 2)) + "px";
                break;
            }

            $this.css(endCSS);
            //shows the element after the work is done
            $this.css("visibility", "visible");
        });
    };
})(jQuery);


$(document).ready(function(){

//GALLERY FILTERING
$('.dyo-img').each(function() {
    var alt = $(this).data('alt');
    var dataFilters = alt.split(" ", 2);
    $(this).attr('data-cat', dataFilters[0]);
    $(this).attr('data-cat-colour', dataFilters[1]);

    //amend alt
    $(this).attr('alt', alt.slice(6));
});

function filterSlides() {
    if ($('.design-your-own .images-holder .images.build-slider').length > 0) {
        $(".design-your-own .images-holder .images.build-slider").slick({
            infinite: true,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            swipe: true,
            fade: false,
            arrows: true,
            prevArrow: '<span class="prev"></span>',
            nextArrow: '<span class="next"></span>',
            
            responsive: [
                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        touchThreshold: 2,
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
}

function filterCategory(catSize, catColour, sorted) {
        
    // reset results list
    $('.dyo-imgs .dyo-img').removeClass('active');
    
    // the filtering in action for all criteria
    var selector = ".filtering .dyo-img";
    if (catSize !== 'cat-all-size') {
        selector = '[data-cat=' + catSize + "]";
    }
    if (catColour !== 'cat-all-col') {
        selector = selector + '[data-cat-colour=' + catColour + "]";
    }

    // show all results
    $(selector).addClass('active');
    $('.filtering .images.build-slider').append($(".images-holder .images-init figure.active").clone());
    $('.gallery-link .build-link').append($(".images-holder .images-init figure.active").clone());
    sorted();
}

// start by showing all items
$('.filtering .images.build-slider').append($(".images-holder .images-init figure").clone());
$('.gallery-link .build-link').append($(".images-holder .images-init figure").clone());
filterSlides();


//FORM PROCESS

var sign;
var firsttxt;
var secondtxt;
var thisdata;

//prevent submit when enter hit (replace this!)
$(window).keydown(function(event){
if( (event.keyCode === 13) ) {
    event.preventDefault();
    return false;
}
});

$('.step-link.btn, .design-your-own .btn_basket.btn').hide();
$('.step-link[data-step-link="1"]').show();

$('.filtering .opt').click(function() {
    thisdata = $(this).parents('.step-content').attr('data-step');
    $('.step-link.btn[data-step-link="' + (thisdata) + '"]').addClass('allowed');

    setTimeout(function() {
        var winHeight = window.innerHeight;
        var btnPos = $('.summary').offset().top;
        var scrollPos = $(document).scrollTop();
        var moveAmt = btnPos - (winHeight + scrollPos);

        if (moveAmt > 20) {
            $("html,body").animate({scrollTop: (btnPos - winHeight) + 10, scrollLeft: 0}, 500);
        }
    }, 500);
});

$('.steps .step-link').click(function() {

    if ($(this).hasClass('allowed') ) {
        $('.step-content').hide();
        $('.step-link').removeClass('active');
        $('.design-your-own .product-form .fixed > .btn').hide();
        
        var target_option = $(this).attr('data-step-link');
        $('.design-your-own .product-form .btn[data-step-link="' + (target_option) + '"]').show();
        $('.step-content[data-step="' + (target_option) + '"]').show();

        //show active icon
        $(this).addClass('active');

        //focus on first input when moving to txt step
        if(target_option === 3 ) {
            $('.input-text.first').focus();
        }
    }
});

$('.step-link.btn').click(function() {

    if ($(this).hasClass('allowed') ) {

        $('.step-content').hide();
        $('.step-link').removeClass('active');
        
        var thisContent = $(this).attr('data-step-link');
        var target_option = (parseInt($(this).attr('data-step-link'), 10)+1);

        $('.step-content[data-step="' + (target_option) + '"]').show();

        $('.btn[data-step-link="' + (target_option) + '"]').show();
        $('.btn[data-step-link="' + (thisContent) + '"]').hide();

        $('.steps .step-link[data-step-link="' + (target_option) + '"]').addClass('active').removeClass('hidden').addClass('allowed');

        //focus on first input when moving to txt step
        if (target_option === 3 ) {
            $('.input-text.first').focus();
        }
    }

    var proPos = $('.steps.links').offset().top;
    var scrollPos = $(document).scrollTop();
    var moveAmt = scrollPos - proPos;

    if (moveAmt > 50) {
        $("html,body").animate({scrollTop: proPos, scrollLeft: 0}, 500);
    }
});

//show preview when size selected
$('.filtering .cat-size .opt').click(function() {
    $('.preview').addClass('allowed');
});

$('.toggle-second').click(function() {
    if ($(this).parents('.fields').children('.second-holder').hasClass('show')) {
        $(this).parents('.fields').removeClass('got');
        $(this).parents('.fields').children('.input-text').removeClass('double').addClass('single');
        $(this).parents('.fields').children('.second-holder').removeClass('show').addClass('hide');
        $(this).parents('.fields').find('.input-text.second').removeClass('show').addClass('hide');
        // $(this).parents('.fields').children('.charcount.second').removeClass('show').addClass('hide');
        $(this).addClass('hide').removeClass('show');
    } else {
        $(this).parents('.fields').addClass('got');
        $(this).parents('.fields').children('.input-text').addClass('double').removeClass('single');
        $(this).parents('.fields').children('.second-holder').removeClass('hide').addClass('show');
        $(this).parents('.fields').find('.input-text.second').removeClass('hide').addClass('show');
        // $(this).parents('.fields').children('.charcount.second').removeClass('hide').addClass('show');
        $(this).addClass('show').removeClass('hide');
    }
});

// once there's some text input, allow next step...
$('.input-text').keyup(function() {
    thisdata = $(this).parents('.step-content').attr('data-step');
    $('.step-link[data-step-link="3"]').addClass('allowed');
});

//build item summary, options stack up below "next" btn
function updateSummary() {
    var first = $('.filtering .cat-size .opt:checked').attr('id');
    var second = $('.filtering .cat-colour .opt:checked').attr('id');

    $('.summary').show();

    if (first === '90') {
        firsttxt = '90cm x 10cm';
        sign = 'big';
    } else {
        firsttxt = '30cm x 10cm';
        sign = 'small';
    }

    if (second !== 'cat-all-col') {
        if (second === 'AW') {
            secondtxt = 'Antique White';
            $('.sign.live-view').addClass('antiquewhite').removeClass('naturalwood');
        } else {
            secondtxt = 'Natural Wood';
            $('.sign.live-view').addClass('naturalwood').removeClass('antiquewhite');
        }
    }

    $('.current-filters.size').html(firsttxt);
    $('.current-filters.colour').html(secondtxt);

    // var thirdFirst = $('.sign .input-text.first').val();
    // var thirdSecond = $('.sign .input-text.second').val();

    if (first !== 'cat-all-size') {
        $('.action').show();
    }
    if (second !== 'cat-all-col') {
        $('.action').show();
    }

    // if (thirdFirst !== '') {
    //     $('.action').show();
    //     $('.current-filters.text').html(thirdFirst + '<br />' + thirdSecond);
    // } else {
    //     $('.current-filters.text').html('');
    // }
}

// function getHeight() {
//     fixedHeight = $('.btn-holder .fixed').outerHeight();
//     $('.btn-holder').css('height', fixedHeight);
// };

// call the filtering function when selects are changed, updates gallery
$('.filtering .opt, .step-link').click(function() {
    updateSummary();
    // getHeight();

    filterCategory($('.filtering .cat-size .opt:checked').attr('id'), $('.filtering .cat-colour .opt:checked').attr('id'), function() {
        $(".design-your-own .images-holder .images.build-slider").slick('unslick');
        $(".design-your-own .images-holder .images.build-slider").empty();
        $('.gallery-link .build-link').empty();
        $('.filtering .images.build-slider').append($(".images-holder .images-init figure.active").clone());
        $('.gallery-link .build-link').append($(".images-holder .images-init figure.active").clone());
        filterSlides();
    });
});

$('.filter-holder, .filtered-by').hide();
// $('.sign.live-text').hide();
$('.sign.live-view').addClass('hide').removeClass('show');
$('.action').hide();

function sizeSelect() {

    if (sign === 'big') {
        $('#charsFirstSm').hide();
        $('#charsSecondSm').hide();
        $('#charsFirstLg').show();
        $('#charsSecondLg').show();

        $('.sign.live-view.large').addClass('show').removeClass('hide');
        $('.sign.live-view.small').addClass('hide').removeClass('show');

        $('.validate.input-text').attr('data-validation-condition', 75);

    } else {
        $('#charsFirstLg').hide();
        $('#charsSecondLg').hide();
        $('#charsFirstSm').show();
        $('#charsSecondSm').show();

        $('.sign.live-view.small').addClass('show').removeClass('hide');
        $('.sign.live-view.large').addClass('hide').removeClass('show');

        $('.validate.input-text').attr('data-validation-condition', 25);
    }

    //calc & display character count
    var lengthFirst = $('.input-text.first').val().length;
    var lengthSecond = $('.input-text.second').val().length;

    var maxlengthFirstLg = 75;
    var maxLengthSecondLg = 75;
    var maxlengthFirstSm = 25;
    var maxLengthSecondSm = 25;

    if ($('.input-text.first').val().length > 0) {
        
        if (sign === 'big') {
            var remainingFirstLg = maxlengthFirstLg - lengthFirst;
            $('#charsFirstLg').text(remainingFirstLg);

            if (remainingFirstLg < 0) {
                $('.input-text.first').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.first').removeClass('error');
                $('.fields .error-icon').hide();
            }
        } else {
            var remainingFirstSm = maxlengthFirstSm - lengthFirst;
            $('#charsFirstSm').text(remainingFirstSm);

            if (remainingFirstSm < 0) {
                $('.input-text.first').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.first').removeClass('error');
                $('.fields .error-icon').hide();
            }
        }   
    }
    if ($('.input-text.second').val().length > 0) {
        
        if (sign === 'big') {
            var remainingSecondLg = maxLengthSecondLg - lengthSecond;
            $('#charsSecondLg').text(remainingSecondLg);

            if (remainingSecondLg < 0) {
                $('.input-text.second').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.second').removeClass('error');
                $('.fields .error-icon').hide();
            }
        } else {
            var remainingSecondSm = maxLengthSecondSm - lengthSecond;
            $('#charsSecondSm').text(remainingSecondSm);

            if (remainingSecondSm < 0) {
                $('.input-text.second').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.second').removeClass('error');
                $('.fields .error-icon').hide();
            }
        }
    }

    $('.input-text.first').keyup(function() {
        lengthFirst = $('.input-text.first').val().length;
    
        if (sign === 'big') {
            var remainingFirstLg = maxlengthFirstLg - lengthFirst;
            $('#charsFirstLg').text(remainingFirstLg);
    
            if (remainingFirstLg < 0) {
                $('.input-text.first').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.first').removeClass('error');
                $('.fields .error-icon').hide();
            }
        } else {
            var remainingFirstSm = maxlengthFirstSm - lengthFirst;
            $('#charsFirstSm').text(remainingFirstSm);
    
            if (remainingFirstSm < 0) {
                $('.input-text.first').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.first').removeClass('error');
                $('.fields .error-icon').hide();
            }
        }
    });

    $('.input-text.second').keyup(function() {
        lengthSecond = $('.input-text.second').val().length;
        
        if (sign === 'big') {
            var remainingSecondLg = maxLengthSecondLg - lengthSecond;
            $('#charsSecondLg').text(remainingSecondLg);
    
            if (remainingSecondLg < 0) {
                $('.input-text.second').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.second').removeClass('error');
                $('.fields .error-icon').hide();
            }
        } else {
            var remainingSecondSm = maxLengthSecondSm - lengthSecond;
            $('#charsSecondSm').text(remainingSecondSm);
    
            if (remainingSecondSm < 0) {
                $('.input-text.second').addClass('error');
                $('.fields .error-icon').show();
            } else {
                $('.input-text.second').removeClass('error');
                $('.fields .error-icon').hide();
            }
        }
    });
}

// on size select...
$('.filtering .cat-size .opt').click(function() {
    sizeSelect();
});

var holderHeight;

function bigFirst() {
    var holderHeight = $('.sign.live-view.show .fields').outerHeight();
    var holderWidth = $('.sign.live-view.show .fields').width();
    
    // fieldOneLen = $('.input-text.second').val().length;

    var fieldOneLen = $('.input-text.first').val().length;

    // var windowWidth = $(window).width();
    var factor = ((holderWidth * 0.0015) );

    // console.log(factor) ;
    
    if (sign === 'big') {
        if (fieldOneLen > 65) {
            $('#large .holder').css({ width : '100%' , height : (holderHeight*1) });
            // console.log('most' + holderWidth);

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factor*1.2,
                maximumFontSize: 95
            });
            $('#large .holder .large-one').css('line-height',1);
            
        } else if (fieldOneLen <= 65 && fieldOneLen > 45) {
            $('#large .holder').css({ width : '98%' , height : (holderHeight*1) });
            // console.log('most' + holderWidth);

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factor,
                maximumFontSize: 95
            });
            $('#large .holder .large-one').css('line-height',1);
            
        } else if (fieldOneLen <= 45 && fieldOneLen > 32) {
            $('#large .holder').css({ width : '94%' , height : (holderHeight*1.05) });
            // console.log('most' + holderWidth);

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factor,
                maximumFontSize: 95
            });
            $('#large .holder .large-one').css('line-height',1);
            
        } else if (fieldOneLen <= 32 && fieldOneLen > 14) {
            $('#large .holder').css({ width : '90%' , height : (holderHeight*1.05) });
            // console.log('mid' + holderWidth);

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factor,
                maximumFontSize: 120
            });
            $('#large .holder .large-one').css('line-height',0.95);

        } else if (fieldOneLen <= 14) {
            $('#large .holder').css({ width : '100%' , height : (holderHeight*1.3) });
            // console.log('least' + holderWidth);

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factor,
                maximumFontSize: 140
            });
            $('#large .holder .large-one').css('line-height',1.05);
        }
        
        
    } else { // SMALL SIGN
        $('#small .holder').css({ width : '94%' , height : (holderHeight*0.8) });
        $('#small .holder .small-one').bigText({
            fontSizeFactor: 0.8,
            maximumFontSize: 90
        });
        // $('#small .holder .small-one').css('line-height',0.5);
    }

    $('#small-one').css('top', '50%');
    $('#large-one').css('top', '50%');    
}

function bigSecond() {
    holderHeight = $('.sign.live-view.show .fields').outerHeight();

    var factorFirst;
    var factorSecond;
    var lineOneSzBase;
    var lineTwoSzBase;
    var lineOneSzLg;
    var lineTwoSzLg;
    var lineOneSzSm;
    var lineTwoSzSm;

    var lineOneSzCalc;
    var lineTwoSzCalc;

    var fieldOneLen = $('.input-text.first').val().length;
    var fieldTwoLen = $('.input-text.second').val().length;
    
    var lineOneHgLg = 0;
    var lineTwoHgLg = 0;
    var lineOnePosLg = 0;
    var lineTwoPosLg = 0;
    var lineOneHgSm = 0;
    var lineTwoHgSm = 0;
    var lineOnePosSm = 0;
    var lineTwoPosSm = 0;

    var holderWidth = $('.sign.live-view.show .fields').width();

    var holderHeightFactor = 0.7;

    var lineTwoSzSet = $('.opts .option.txtsize .opt-txtsize:checked').attr('id');
    // var lineTwoSqCalc = $('.sign.live-view.show .holder > div:first-child').css('transform');

    if (sign === 'big') {

        factorFirst = ((holderWidth * 0.0006) );
        factorSecond = ((holderWidth * 0.0006) );

        lineOneSzBase = holderWidth * 0.09;
        lineTwoSzBase = parseInt($('#large-one').css('font-size'), 10);

        lineOneSzCalc = parseInt($('#large-one').css('font-size'), 10);
        lineTwoSzCalc = parseInt($('#large-two').css('font-size'), 10);

        // lineTwoSqCalc = $('#large-one').css('transform');

        // if (lineTwoSzSet === 'txt-0') {
        //     holderHeightFactor = 0.85;
        //     // factorFirst = factorFirst*1.2;
        
        //     if (fieldOneLen > 30) {
        //         lineOneSzLg = lineOneSzBase*1.6;
        //         lineTwoSzLg = lineOneSzBase*0.55;

        //         if (fieldTwoLen > 20 && fieldTwoLen <= 30) {
        //             lineTwoSzLg = lineOneSzBase*0.5;
        //         }
        //         if (fieldTwoLen > 30 && fieldTwoLen <= 45) {
        //             lineTwoSzLg = lineOneSzBase*0.45;
        //         }
        //         if (fieldTwoLen > 45) {
        //             lineTwoSzLg = lineOneSzBase*0.4;
        //         }
        //     } else {
        //         lineOneSzLg = lineOneSzBase*1.6;
        //         lineTwoSzLg = lineOneSzBase*0.6;

        //         if (fieldTwoLen > 20 && fieldTwoLen <= 30) {
        //             lineTwoSzLg = lineOneSzBase*0.55;
        //         }
        //         if (fieldTwoLen > 30 && fieldTwoLen <= 45) {
        //             lineTwoSzLg = lineOneSzBase*0.5;
        //         }
        //         if (fieldTwoLen > 45) {
        //             lineTwoSzLg = lineOneSzBase*0.45;
        //         }
        //     }
    
        //     if ( (lineTwoSzLg > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
        //         lineTwoSzLg = lineOneSzCalc;
        //     }
    
        //     lineOneHgLg = 0.15;
        //     lineTwoHgLg = -0.15;
        //     lineOnePosLg = 4;
        //     lineTwoPosLg = -6;
        // } else
        
        if (lineTwoSzSet === 'txt-1') {
            holderHeightFactor = 0.75;
            // factorFirst = factorFirst*1.1;
            
            if (fieldOneLen > 30) {
                lineOneSzLg = lineOneSzBase*1.5;
                lineTwoSzLg = lineOneSzBase*0.65;

                if (fieldTwoLen > 20 && fieldTwoLen <= 30) {
                    lineTwoSzLg = lineOneSzBase*0.55;
                }
                if (fieldTwoLen > 30 && fieldTwoLen <= 45) {
                    lineTwoSzLg = lineOneSzBase*0.5;
                }
                if (fieldTwoLen > 45) {
                    lineTwoSzLg = lineOneSzBase*0.45;
                }
            } else {
                lineOneSzLg = lineOneSzBase*1.8;
                lineTwoSzLg = lineOneSzBase*0.7;

                if (fieldTwoLen > 20 && fieldTwoLen <= 30) {
                    lineTwoSzLg = lineOneSzBase*0.6;
                }
                if (fieldTwoLen > 30 && fieldTwoLen <= 45) {
                    lineTwoSzLg = lineOneSzBase*0.55;
                }
                if (fieldTwoLen > 45) {
                    lineTwoSzLg = lineOneSzBase*0.5;
                }
            }
    
            if ( (lineTwoSzLg > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
                lineTwoSzLg = lineOneSzCalc;
            }
    
            lineOneHgLg = 0.15;
            lineTwoHgLg = 0;
            lineOnePosLg = 0;
            lineTwoPosLg = -6;
        } else {
            holderHeightFactor = 0.7;
            // factorFirst = factorFirst;
            lineOneSzBase = holderWidth * 0.15;



            lineOneSzLg = lineOneSzBase;
            lineTwoSzLg = lineOneSzBase;
    
            if ( (lineTwoSzLg > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
                lineTwoSzLg = lineOneSzCalc;
            }

            // factorSecond = factorSecond*1.1;
    
            lineOneHgLg = 0.15;
            lineTwoHgLg = 0;
            lineOnePosLg = 0;
            lineTwoPosLg = -6;
        }

        // if lines equal/nearly equal
        // if ( (fieldDif < 5 && fieldDif > -5) || (fieldTwoLen > fieldOneLen) || (fieldTwoLen < fieldOneLen) ) {  }

        if (fieldOneLen > 60) {
            $('#large .holder').css({ width : '98%' , height : (holderHeight*holderHeightFactor) });

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factorFirst,
                maximumFontSize: lineOneSzLg
            });
            $('#large .holder .large-two').bigText({
                fontSizeFactor: factorSecond,
                maximumFontSize: lineTwoSzLg,
                minimumScale: 0.9
            });

            $('#large .holder .large-one').css('line-height', 0.8 + lineOneHgLg);
            $('#large .holder .large-two').css('line-height', 0.6 + lineTwoHgLg);
            $('#large-one').css('top', 24 + lineOnePosLg + '%');
            $('#large-two').css('top', 72 + lineTwoPosLg + '%');

        } else if (fieldOneLen <= 60 && fieldOneLen > 35) {
            $('#large .holder').css({ width : '98%' , height : (holderHeight*holderHeightFactor) });

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factorFirst,
                maximumFontSize: lineOneSzLg
            });
            $('#large .holder .large-two').bigText({
                fontSizeFactor: factorSecond,
                maximumFontSize: lineTwoSzLg
            });

            $('#large .holder .large-one').css('line-height', 0.8 + lineOneHgLg);
            $('#large .holder .large-two').css('line-height', 0.6 + lineTwoHgLg);
            $('#large-one').css('top', 24 + lineOnePosLg + '%');
            $('#large-two').css('top', 64 + lineTwoPosLg + '%');

        }
        else if (fieldOneLen <= 35 && fieldOneLen > 14) {
            $('#large .holder').css({ width : '96%' , height : (holderHeight*holderHeightFactor) });

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factorFirst,
                maximumFontSize: lineOneSzLg
            });
            $('#large .holder .large-two').bigText({
                fontSizeFactor: factorSecond,
                maximumFontSize: lineTwoSzLg,
                minimumScale: 0.6
            });

            $('#large .holder .large-one').css('line-height',0.8 + lineOneHgLg);
            $('#large .holder .large-two').css('line-height',0.6 + lineTwoHgLg);
            $('#large-one').css('top', 24 + lineOnePosLg + '%');
            $('#large-two').css('top', 58 + lineTwoPosLg + '%');

        } else if (fieldOneLen <= 14) {
            $('#large .holder').css({ width : '96%' , height : (holderHeight*holderHeightFactor) });

            $('#large .holder .large-one').bigText({
                fontSizeFactor: factorFirst,
                maximumFontSize: lineOneSzLg
            });
            $('#large .holder .large-two').bigText({
                fontSizeFactor: factorSecond,
                maximumFontSize: lineTwoSzLg
            });

            $('#large .holder .large-one').css('line-height',0.8 + lineOneHgLg);
            $('#large .holder .large-two').css('line-height',0.6 + lineTwoHgLg);
            $('#large-one').css('top', 24 + lineOnePosLg + '%');
            $('#large-two').css('top', 52 + lineTwoPosLg + '%');
        }

        // $('#large-two').css('transform', lineTwoSqCalc);
        
    } else { // SMALL SIGN

        factorFirst = ((holderWidth * 0.0022) );
        factorSecond = ((holderWidth * 0.0022) );

        lineOneSzBase = holderWidth * 0.2;
        lineTwoSzBase = parseInt($('#small-one').css('font-size'), 10);

        lineOneSzCalc = parseInt($('#small-one').css('font-size'), 10);
        lineTwoSzCalc = parseInt($('#small-two').css('font-size'), 10);


        // if (lineTwoSzSet === 'txt-0') {
        //     holderHeightFactor = 0.9;
        //     lineOneSzSm = lineOneSzBase*1.2;

        //     if (fieldTwoLen > 12) {
        //         lineTwoSzSm = lineOneSzBase*0.4;
        //     } else {
        //         lineTwoSzSm = lineOneSzBase*0.5;
        //     }
    
        //     if ( (lineTwoSzSm > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
        //         lineTwoSzSm = lineOneSzCalc;
        //     }
    
        //     lineOneHgSm = 0;
        //     lineTwoHgSm = -0.15;
        //     lineOnePosSm = 3;
        //     lineTwoPosSm = 4;

        // } else 
        
        if (lineTwoSzSet === 'txt-1') {
            holderHeightFactor = 1;
            lineOneSzSm = lineOneSzBase*1.1;

            if (fieldOneLen > 12) {

                lineOneHgSm = 0.2;
                lineTwoHgSm = 0.8;
                lineOnePosSm = 4;
                lineTwoPosSm = -6;
                
            } else {

                lineOneHgSm = 0.2;
                lineTwoHgSm = 0.2;
                lineOnePosSm = 4;
                lineTwoPosSm = -6;
            } 

            if (fieldTwoLen > 18) {
                lineTwoSzSm = lineOneSzBase*0.4;

                // lineOneHgSm = 0.5;
                // lineTwoHgSm = -0.2;
                // lineOnePosSm = -2;
                // lineTwoPosSm = -6;   
            } else if (fieldTwoLen > 10 && fieldTwoLen <= 18) {
                lineTwoSzSm = lineOneSzBase*0.6;

                // lineOneHgSm = 0.5;
                // lineTwoHgSm = -0.2;
                // lineOnePosSm = -2;
                // lineTwoPosSm = -6;   
            } else {
                lineTwoSzSm = lineOneSzBase*0.8;
            }

            if ( (lineTwoSzSm > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
                lineTwoSzSm = lineOneSzCalc;
            }
    
        } else {
            holderHeightFactor = 1;
            // factorFirst = factorFirst;
            lineOneSzSm = lineOneSzBase*1.1;
            lineTwoSzSm = lineOneSzBase*1.1;

            if (fieldOneLen > 12) {

                lineOneHgSm = 0.2;
                lineTwoHgSm = 0.2;
                lineOnePosSm = 0;
                lineTwoPosSm = -2;
                // console.log('> 12');
                
            } else {

                lineOneHgSm = 0.2;
                lineTwoHgSm = 0.2;
                lineOnePosSm = -2;
                lineTwoPosSm = -8;
                // console.log('< 12');
            } 
    
            if ( (lineTwoSzSm > lineTwoSzBase) || (lineTwoSzCalc > lineTwoSzBase) ) {
                lineTwoSzSm = lineOneSzCalc;
            }
        }

        $('#small .holder').css({ width : '94%' , height : (holderHeight*holderHeightFactor) });

        $('#small .holder .small-one').bigText({
            fontSizeFactor: factorFirst,
            maximumFontSize: lineOneSzSm
        });
        $('#small .holder .small-two').bigText({
            fontSizeFactor: factorSecond,
            maximumFontSize: lineTwoSzSm
        });

        $('#small .holder .small-one').css('line-height',1 + lineOneHgSm);
        $('#small .holder .small-two').css('line-height',0.7 + lineTwoHgSm);
        $('#small-one').css('top', 32 + lineOnePosSm + '%');
        $('#small-two').css('top', 58 + lineTwoPosSm + '%');

        // $('#small-two').css({transform: lineTwoSqCalc });
    }
}


//build preview, matching inputs with preview fields
// var fieldTwo = $('.input-text.second').val();
// $('.step-link.one').click(function() {
//     fieldTwo = $('.input-text.second').val();
//     console.log('step '+fieldTwo);
// });
$('.filtering .cat-size .opt').click(function() {
    var fieldTwo = $('.input-text.second').val();
    // console.log('opt '+fieldTwo);

    if ($('.second-holder').hasClass('show') && fieldTwo !== ' ') {
        bigSecond();
        
    } else {
        bigFirst();
        // bigFirstHheight();
    }
});

//rebuild on resize
var windowWidth = $(window).width();
$(window).on("resize",function() {

    //check 'resize' isn't just iOS scroll
    if ($(window).width() !== windowWidth) {
        // Update the window width for next time
        windowWidth = $(window).width();
        bigFirst();

        if ($('.second-holder').hasClass('show')) {
            bigSecond();
        }
    }
});

//rebuild on txt change
$('.mirror-one').on('keyup', function() {
    $('#small-one, #large-one').text($('.input-text.first').val());

    var fieldTwo = $('.input-text.second').val();
    // bigFirstHheight();

    if ($('.second-holder').hasClass('show') && fieldTwo !== '') {
        // bigFirst();
        bigSecond();
        // console.log('type first fire second');
        
    } else {
        bigFirst();
        // console.log('type first fire first');
    }
});
$('.mirror-two').on('keyup', function() {
    $('#small-two, #large-two').text($('.input-text.second').val());
    var fieldTwo = $('.input-text.second').val();

    if (fieldTwo !== '') {
        bigSecond();
        // console.log('type second fire second');
    } else {
        bigFirst();
        // console.log('type second reset first');
    }
});

//rebuild on second toggle
$('.opts .option.txtsize').hide();

$('.toggle-second').click(function() {
    if ($('.second-holder').hasClass('show')) {
        var fieldTwo = $('.input-text.second').val();

        $('.mirror-two').focus();
        if (fieldTwo !== '') {
            bigSecond();
        }
        $('.opts .option.txtsize').show();
        //and on second txt size change
        $('.opts .option.txtsize .opt-txtsize').click(function() {
            bigSecond();
        });
    } else {
        $('.input-text.second').val('');
        $('#small-two').text('');
        $('#large-two').text('');
        bigFirst();
        $('.opts .option.txtsize').hide();
        $('.opts .option.txtsize .opt-txtsize#txt-2').prop('checked', true);
    }
});

//skip the first click if size already selected
var pageVar = window.location.search.replace('?variant=' , '');
if (pageVar !== '') {
    // .prop('checked', true)
    $('.filtering .cat-size .opt[data-varid="' + (pageVar) + '"]').click();
    updateSummary();
    sizeSelect();
}

});